import { NumericFormat } from 'react-number-format';
import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';

import { useInputContext } from '../context/InputContext';
import { NumberProps } from '../types';

import cn from './Input.module.scss';

export const Number = ({
  allow_negative,
  thousand_separator,
  decimal_scale,
  min,
  max,
}: Omit<NumberProps, 'children'>) => {
  const {
    inputRef,
    placeholder,
    typed_value,
    text_align,
    disabled,
    onFocus,
    onBlur,
    onKeyDown,
    onChange,
    theme,
  } = useInputContext();

  const field_theme = useFieldTheme(theme?.field);
  return (
    <NumericFormat
      getInputRef={inputRef}
      className={cn.input}
      value={typed_value}
      placeholder={placeholder}
      allowNegative={allow_negative}
      thousandSeparator={thousand_separator}
      valueIsNumericString
      allowLeadingZeros
      decimalScale={decimal_scale}
      disabled={disabled}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      style={{ textAlign: text_align, padding: field_theme.general.padding }}
      isAllowed={({ floatValue }) => {
        if (floatValue === undefined) return true;
        if (min !== undefined && floatValue < min) return false;
        if (max !== undefined && floatValue > max) return false;
        return true;
      }}
      onValueChange={({ formattedValue, value, floatValue }) => {
        onChange({ formatted_value: formattedValue, value, float_value: floatValue });
      }}
    />
  );
};
